(() => {
  'use strict';
  if (customElements.get('product-zoom')) return;
  class ProductZoom extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.gallery = this.closest('[data-product-gallery]');
      this.links = [...this.gallery.querySelectorAll('[data-zoom-image]')];
      this.dialog = this.querySelector('dialog');
      if (!this.dialog.showModal || !this.links.length) return;
      this.viewport = this.querySelector('[data-zoom-viewport]');
      this.photo = this.querySelector('[data-zoom-photo]');
      this.error = this.querySelector('[data-zoom-error]');
      this.pointers = new Map();
      this.scale = 1; this.x = 0; this.y = 0; this.index = 0; this.max = 1;
      const on = (el, event, handler, options = {}) => el.addEventListener(event, handler, {...options, signal});
      this.links.forEach((link, index) => {
        link.setAttribute('role', 'button');
        link.setAttribute('aria-pressed', 'false');
        on(link, 'keydown', e => { if (e.key === ' ') { e.preventDefault(); link.click(); } });
        on(link, 'click', e => {
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        if (e.pointerType === 'touch') this.openGallery(index, link);
        else this.toggleInline(link, e);
        });
        on(link, 'pointermove', e => { if (this.inlineLink === link && e.pointerType === 'mouse') this.panInline(e); });
        on(link, 'pointerleave', () => { if (this.inlineLink === link) this.clearInline(); });
        on(link, 'keydown', e => { if (e.key === 'Escape') this.clearInline(); });
        on(link.parentElement.querySelector('[data-zoom-expand]'), 'click', e => {
        this.openGallery(index, e.currentTarget);
        });
      });
      const movePhoto = direction => {
        this.clearInline();
        const media = [...this.gallery.querySelectorAll('.pdp__stage [data-media-id]')];
        const index = media.findIndex(item => !item.hidden);
        this.gallery.__showMedia?.(media[(index + direction + media.length) % media.length].dataset.mediaId);
      };
      ['prev', 'next'].forEach(key => {
        const button = this.gallery.querySelector(`[data-photo-${key}]`);
        if (button) on(button, 'click', () => movePhoto(key === 'prev' ? -1 : 1));
      });
      this.gallery.querySelectorAll('[data-thumb]').forEach(thumb => {
        on(thumb, 'click', () => this.clearInline());
        on(thumb, 'pointerenter', e => {
          if (e.pointerType === 'mouse') { this.clearInline(); this.gallery.__showMedia?.(thumb.dataset.thumb); }
        });
      });
      on(this.querySelector('[data-zoom-close]'), 'click', () => this.dialog.close());
      on(this.dialog, 'close', () => {
        document.body.style.overflow = this.oldOverflow || '';
        this.pointers.clear(); this.opener?.focus();
      });
      on(this.querySelector('[data-zoom-prev]'), 'click', () => this.select(this.index - 1));
      on(this.querySelector('[data-zoom-next]'), 'click', () => this.select(this.index + 1));
      this.querySelectorAll('[data-zoom-select]').forEach(button => on(button, 'click', () => this.select(Number(button.dataset.zoomSelect))));
      on(this.querySelector('[data-zoom-in]'), 'click', () => this.zoom(this.scale * 1.5));
      on(this.querySelector('[data-zoom-out]'), 'click', () => this.zoom(this.scale / 1.5));
      on(this.querySelector('[data-zoom-reset]'), 'click', () => this.reset());
      on(this.dialog, 'keydown', e => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.select(this.index - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.select(this.index + 1); }
        if (e.key === '+' || e.key === '=') { e.preventDefault(); this.zoom(this.scale * 1.5); }
        if (e.key === '-') { e.preventDefault(); this.zoom(this.scale / 1.5); }
        if (e.key === '0') { e.preventDefault(); this.reset(); }
      });
      on(this.photo, 'load', () => { this.photo.hidden = false; this.viewport.removeAttribute('aria-busy'); this.fit(); });
      on(this.photo, 'error', () => { this.photo.hidden = true; this.error.hidden = false; this.viewport.removeAttribute('aria-busy'); this.max = 1; this.render(); });
      on(this.viewport, 'wheel', e => {
        e.preventDefault(); this.zoom(this.scale * (e.deltaY < 0 ? 1.15 : 1 / 1.15), this.point(e));
      }, {passive: false});
      on(this.viewport, 'pointerdown', e => {
        if (e.button !== 0) return;
        this.viewport.setPointerCapture(e.pointerId);
        this.pointers.set(e.pointerId, this.point(e));
        this.start = {point: this.point(e), x: this.x, y: this.y, scale: this.scale};
        this.moved = false;
        if (this.pointers.size === 2) this.pinch = this.gesture();
        this.viewport.dataset.dragging = 'true';
      });
      on(this.viewport, 'pointermove', e => {
        const point = this.point(e);
        if (!this.pointers.has(e.pointerId)) {
          if (e.pointerType === 'mouse' && this.scale > 1) {
            this.x = (0.5 - (point.x / this.viewport.clientWidth + 0.5)) * Math.max(0, this.baseW * this.scale - this.viewport.clientWidth);
            this.y = (0.5 - (point.y / this.viewport.clientHeight + 0.5)) * Math.max(0, this.baseH * this.scale - this.viewport.clientHeight);
            this.render();
          }
          return;
        }
        this.pointers.set(e.pointerId, point);
        if (this.pointers.size === 2) {
          this.moved = true;
          const gesture = this.gesture();
          if (this.pinch) this.zoom(this.scale * gesture.distance / this.pinch.distance, gesture.center);
          this.pinch = gesture;
        } else if (this.start) {
          const dx = point.x - this.start.point.x, dy = point.y - this.start.point.y;
          if (Math.hypot(dx, dy) > 6) this.moved = true;
          this.x = this.start.x + dx; this.y = this.start.y + dy; this.render();
        }
      });
      const end = e => {
        const start = this.start;
        this.pointers.delete(e.pointerId);
        if (e.type === 'pointerup' && !this.moved && start && this.pointers.size === 0) this.zoom(this.scale > 1 ? 1 : 4, this.point(e));
        if (e.type === 'pointerup' && this.moved && start?.scale === 1 && e.pointerType === 'touch' && !this.pinch) {
          const dx = this.point(e).x - start.point.x;
          if (Math.abs(dx) > 80) this.select(this.index + (dx < 0 ? 1 : -1));
        }
        this.pinch = null;
        if (this.pointers.size === 1) this.start = {point: [...this.pointers.values()][0], x: this.x, y: this.y, scale: this.scale};
        if (!this.pointers.size) { this.start = null; this.viewport.dataset.dragging = 'false'; }
      };
      on(this.viewport, 'pointerup', end); on(this.viewport, 'pointercancel', end);
      this.resize = new ResizeObserver(() => { if (this.dialog.open && !this.photo.hidden) this.fit(); });
      this.resize.observe(this.viewport);
      this.mediaObserver = new MutationObserver(() => {
        if (this.inlineLink?.closest('[data-media-id]').hidden) this.clearInline();
      });
      this.mediaObserver.observe(this.gallery.querySelector('.pdp__stage'), {subtree: true, attributes: true, attributeFilter: ['hidden']});
    }
    disconnectedCallback() {
      this.clearInline();
      if (this.dialog?.open) this.dialog.close();
      this.abort?.abort(); this.resize?.disconnect(); this.mediaObserver?.disconnect();
    }
    openGallery(index, opener) {
      this.clearInline(); this.opener = opener;
      this.oldOverflow = document.body.style.overflow;
      this.dialog.showModal(); document.body.style.overflow = 'hidden'; this.select(index);
    }
    clearInline() {
      if (!this.inlineLink) return;
      this.inlineLink.setAttribute('aria-pressed', 'false');
      this.inlineLink.classList.remove('is-zoomed');
      this.inlineImage?.remove(); this.inlineImage = null; this.inlineLink = null;
    }
    toggleInline(link, event) {
      if (this.inlineLink === link) { this.clearInline(); return; }
      this.clearInline();
      this.inlineLink = link;
      const img = new Image();
      img.className = 'pdp__inline-zoom'; img.alt = ''; img.setAttribute('aria-hidden', 'true');
      img.onload = () => {
        if (this.inlineLink !== link) return;
        const fit = Math.min(link.clientWidth / img.naturalWidth, link.clientHeight / img.naturalHeight);
        const scale = 4;
        if (scale <= 1) { this.clearInline(); return; }
        this.inlineW = img.naturalWidth * fit * scale; this.inlineH = img.naturalHeight * fit * scale;
        img.style.width = `${this.inlineW}px`; img.style.height = `${this.inlineH}px`;
        this.inlineImage = img; link.append(img); link.classList.add('is-zoomed'); link.setAttribute('aria-pressed', 'true');
        this.panInline(event);
      };
      img.onerror = () => { if (this.inlineLink === link) this.clearInline(); };
      img.src = link.href;
    }
    panInline(event) {
      if (!this.inlineImage || !this.inlineLink) return;
      const rect = this.inlineLink.getBoundingClientRect();
      const px = event.detail === 0 && event.type === 'click' ? 0.5 : Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
      const py = event.detail === 0 && event.type === 'click' ? 0.5 : Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height));
      const x = this.inlineW > rect.width ? (rect.width - this.inlineW) * px : (rect.width - this.inlineW) / 2;
      const y = this.inlineH > rect.height ? (rect.height - this.inlineH) * py : (rect.height - this.inlineH) / 2;
      this.inlineImage.style.transform = `translate(${x}px, ${y}px)`;
    }
    point(e) {
      const rect = this.viewport.getBoundingClientRect();
      return {x: e.clientX - rect.left - rect.width / 2, y: e.clientY - rect.top - rect.height / 2};
    }
    gesture() {
      const [a, b] = [...this.pointers.values()];
      return {distance: Math.max(1, Math.hypot(a.x - b.x, a.y - b.y)), center: {x: (a.x + b.x) / 2, y: (a.y + b.y) / 2}};
    }
    select(index) {
      this.index = (index + this.links.length) % this.links.length;
      const link = this.links[this.index];
      this.reset(); this.pointers.clear(); this.start = null;
      this.photo.hidden = true; this.error.hidden = true; this.max = 1;
      this.viewport.setAttribute('aria-busy', 'true');
      this.photo.alt = link.querySelector('img').alt;
      this.photo.src = link.href;
      this.querySelector('[data-zoom-count]').textContent = `${this.index + 1} / ${this.links.length}`;
      this.querySelectorAll('[data-zoom-select]').forEach((button, i) => {
        if (i === this.index) button.setAttribute('aria-current', 'true'); else button.removeAttribute('aria-current');
      });
      ['prev', 'next'].forEach(key => { this.querySelector(`[data-zoom-${key}]`).disabled = this.links.length < 2; });
      this.render();
      if (this.photo.complete && this.photo.naturalWidth) { this.photo.hidden = false; this.viewport.removeAttribute('aria-busy'); this.fit(); }
    }
    fit() {
      const width = this.photo.naturalWidth, height = this.photo.naturalHeight;
      if (!width || !height) return;
      const ratio = Math.min((this.viewport.clientWidth - 24) / width, (this.viewport.clientHeight - 24) / height, 1);
      this.baseW = width * ratio; this.baseH = height * ratio;
      this.photo.style.width = `${this.baseW}px`; this.photo.style.height = `${this.baseH}px`;
      this.max = 4;
      this.reset();
    }
    reset() { this.scale = 1; this.x = 0; this.y = 0; if (this.photo) this.render(); }
    zoom(scale, point = {x: 0, y: 0}) {
      const next = Math.max(1, Math.min(this.max, scale));
      this.x = point.x - (point.x - this.x) * next / this.scale;
      this.y = point.y - (point.y - this.y) * next / this.scale;
      this.scale = next; this.render();
    }
    render() {
      const limitX = Math.max(0, ((this.baseW || 0) * this.scale - this.viewport.clientWidth) / 2);
      const limitY = Math.max(0, ((this.baseH || 0) * this.scale - this.viewport.clientHeight) / 2);
      this.x = Math.max(-limitX, Math.min(limitX, this.x)); this.y = Math.max(-limitY, Math.min(limitY, this.y));
      this.photo.style.transform = `translate(calc(-50% + ${this.x}px), calc(-50% + ${this.y}px)) scale(${this.scale})`;
      this.viewport.dataset.enlarged = String(this.scale > 1);
      this.querySelector('[data-zoom-in]').disabled = this.scale >= this.max - 0.01;
      this.querySelector('[data-zoom-out]').disabled = this.scale <= 1;
    }
  }
  customElements.define('product-zoom', ProductZoom);
})();
